<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons" *ngIf="id == 0">Add Credential</h4>
    <h4 class="modal-title" id="labelButtons" *ngIf="id > 0">Edit Credential</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <form [formGroup]="form" #f="ngForm" autocomplete="off" *ngIf="displayResults">
        <fieldset>
            <div class="row">
                <div class="col-sm-3 mvd_form-group">
                    <label class="required" title="* Required">License Number</label>
                    <input class="mvd_form-control"
                           type="text"
                           maxlength="25"
                           name="credentialNumber"
                           formControlName="credentialNumber">
                    <control-validation-messages control="credentialNumber"></control-validation-messages>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>Travel ID</label>
                    <input formControlName="travelId" name="travelId" type="checkbox">
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>Digital Image Check</label>
                    <input formControlName="imageCheck" name="imageCheck" type="checkbox">
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3 mvd_form-group">
                    <label for="country" class="required" title="* Required">Country</label>
                    <select class="mvd_form-control" id="country" name="countryId" formControlName="countryId" (change)="countryChange()">
                        <option *ngFor="let c of countries" [value]="c.id">{{ c.displayValue }}</option>
                    </select>
                    <control-validation-messages control="countryId"></control-validation-messages>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label class="required" title="* Required" for="state">State</label>
                    <select class="mvd_form-control" id="stateId" name="stateId" formControlName="stateId">
                        <option></option>
                        <option *ngFor="let s of getJurisdictions()" [value]="s.id">{{ s.code }}</option>
                    </select>
                    <control-validation-messages control="stateId"></control-validation-messages>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label class="required" title="* Required">Issue Date</label>
                    <p-calendar placeholder="mm/dd/yyyy"
                                name="issueDate"
                                [maxDate]="data.expirationDate"
                                [showIcon]="true"
                                dateFormat="mm/dd/yy"
                                formControlName="issueDate">
                    </p-calendar>
                    <control-validation-messages control="issueDate"></control-validation-messages>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label class="required" title="* Required">Expiration Date</label>
                    <p-calendar placeholder="mm/dd/yyyy"
                                name="expirationDate"
                                [minDate]="data.issueDate"
                                [showIcon]="true"
                                dateFormat="mm/dd/yy"
                                formControlName="expirationDate">
                    </p-calendar>
                    <control-validation-messages control="expirationDate"></control-validation-messages>
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="form.hasError('issueDateMustBeBeforeExpirationDate')">Expiration date must be after Issue Date</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <label class="required" title="* Required">Classes</label>
                    <p-multiSelect [options]="licenseClassTypes"
                                    name="licenseClassTypeIds"
                                    formControlName="licenseClassTypeIds"
                                    (onChange)="licenseClassTypeSelectionChanged()">
                    </p-multiSelect>
                </div>
                <div class="col-sm-6 mvd_form-group">
                    <label>Endorsements</label>
                    <p-multiSelect [options]="endorsementTypes"
                                    formControlName="endorsementTypeIds"
                                    name="endorsementTypeIds">
                    </p-multiSelect>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <label>Restrictions</label>
                    <p-multiSelect [options]="restrictionTypes"
                                    formControlName="restrictionTypeIds"
                                    name="restrictionTypeIds">
                    </p-multiSelect>
                </div>
            </div>
        </fieldset>
    </form>    
</div>
<div class="modal-footer">
    <div class="btn--group" *ngIf="displayResults">
        <button (click)="cancel()" class="btn--default" type="button">Cancel</button>
        <mvm-spinner-btn [isDisabled]="!form?.valid || showButton" [isLoading]="showButtonLoading" btnText="Save" (clicked)="save()"></mvm-spinner-btn>
    </div>
</div>